<div class="account-pages pt-5 m-auto">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">

          <div class="card-body p-4" *ngIf="token || currentUser">

            <div class="text-center w-75 m-auto">
              <h5 class="text-uppercase text-center font-bold mt-4">Password reset</h5>
              <div class="icon-container"><i class="fe-lock header-icon"></i></div>
            </div>


            <div class="form-group mb-3" *ngIf="!currentUser">
              <label for="emailaddress">Email address</label>
              <input [(ngModel)]="email" [ngModelOptions]="{standalone: true}" class="form-control" type="email"
                     id="emailaddress" required="" placeholder="Enter your email">
            </div>

            <div class="form-group mb-3" *ngIf="!!currentUser">
              <label for="oldpassword">Current Password<span class="text-danger">*</span></label>
              <input [formControl]="oldPassword" id="oldpassword" type="password"
                     placeholder="Enter your current password" required class="form-control">

              <ul *ngIf="submitted || oldPassword.touched" class="parsley-errors-list filled">
                <li *ngIf="oldPassword.hasError('required')" class="parsley-required">This value is required.</li>
                <li *ngIf="oldPassword.hasError('minLength')" class="parsley-required">
                  Password must be atleast 8
                  characters.
                </li>
                <li *ngIf="oldPassword.hasError('pattern')" class="parsley-required">
                  Password requres 1 Capital, 1
                  Number and a special character
                </li>
              </ul>

            </div>

            <div class="form-group mb-3">
              <label for="passWord1">New Password<span class="text-danger">*</span></label>
              <input [formControl]="password" id="passWord1" type="password" placeholder="Enter your new password"
                     required class="form-control">

              <ul *ngIf="submitted || password.touched" class="parsley-errors-list filled">
                <li *ngIf="password.hasError('required')" class="parsley-required">This value is required.</li>
                <li *ngIf="password.hasError('minLength')" class="parsley-required">Password must be atleast 8 characters long.</li>
                <li *ngIf="password.hasError('pattern')" class="parsley-required">Password requres 1 Capital, 1 Number and a special character</li>
              </ul>

            </div>
            <div class="form-group mb-3">
              <label for="passWord2">Confirm New Password <span class="text-danger">*</span></label>
              <input [formControl]="confirmPassword" type="password" required placeholder="Enter your new password"
                     class="form-control" id="passWord2">
              <ul *ngIf="submitted || confirmPassword.touched" class="parsley-errors-list filled">
                <li *ngIf="confirmPassword.hasError('required')" class="parsley-required">This value is required.</li>
                <li *ngIf="confirmPassword.hasError('passwordsMatch')" class="parsley-required">
                  Passwords do not match
                </li>
              </ul>
            </div>

            <div class="form-group my-3">
              <button type="button" class="btn btn-info waves-effect waves-light float-left m-2" (click)="goBack()">
                < Back
              </button>
              <button (click)="reset()" class="btn btn-gradient waves-effect waves-light mt-2 col-lg-4 col-md-6" type="submit"><i class="fe-check mr-1"></i>Confirm</button>
            </div>

          </div> <!-- end card-body -->
        </div><!-- end card -->
      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>
